import { ca } from '@cian/analytics';

export const trackOffersBannerShow = () => trackOffersBannerEvent('Show_sopr');
export const trackOffersBannerClick = () => trackOffersBannerEvent('Click_sopr');

function trackOffersBannerEvent(action: 'Show_sopr' | 'Click_sopr') {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action,
    label: 'booking_confident_banner',
    useLastProducts: true,
  });
}
